/* RESPONSIBLE TEAM: team-proactive-support */
import {
  type GridSettings,
  type OptionalGridSettings,
  DEFAULT_GRID_SETTINGS,
} from './settings/grid';
import {
  type NodeSettings,
  type OptionalNodeSettings,
  DEFAULT_NODE_SETTINGS,
} from './settings/node';
import {
  type ScaleSettings,
  type OptionalScaleSettings,
  DEFAULT_SCALE_SETTINGS,
} from './settings/scale';
import {
  ScrollSettings,
  type OptionalScrollSettings,
  DEFAULT_SCROLL_SETTINGS,
} from './settings/scroll';
import {
  type PerformanceSettings,
  type OptionalPerformanceSettings,
  DEFAULT_PERFORMANCE_SETTINGS,
} from './settings/performance';

interface Inputs {
  grid: OptionalGridSettings;
  node: OptionalNodeSettings;
  scale: OptionalScaleSettings;
  performance: OptionalPerformanceSettings;
  scroll: OptionalScrollSettings;
}

export default class Settings {
  grid: GridSettings = Object.assign({}, DEFAULT_GRID_SETTINGS);
  node: NodeSettings = Object.assign({}, DEFAULT_NODE_SETTINGS);
  scale: ScaleSettings = Object.assign({}, DEFAULT_SCALE_SETTINGS);
  performance: PerformanceSettings = Object.assign({}, DEFAULT_PERFORMANCE_SETTINGS);
  scroll: ScrollSettings = new ScrollSettings(Object.assign({}, DEFAULT_SCROLL_SETTINGS));

  static fromJSON(inputs: Inputs): Settings {
    let settings = new Settings();

    if (inputs.grid) {
      settings.grid = Object.assign({}, settings.grid, inputs.grid);
    }

    if (inputs.node) {
      settings.node = Object.assign({}, settings.node, inputs.node);
    }

    if (inputs.scale) {
      settings.scale = Object.assign({}, settings.scale, inputs.scale);
    }

    if (inputs.performance) {
      settings.performance = Object.assign({}, settings.performance, inputs.performance);
    }

    if (inputs.scroll) {
      settings.scroll = new ScrollSettings(
        Object.assign({}, DEFAULT_SCROLL_SETTINGS, inputs.scroll),
      );
    }

    return settings;
  }
}
